import React, { useEffect, useRef, useState } from "react";
import { googleApi } from "../../actions/GooglePlaceApi";
import AddIcon from "@mui/icons-material/Add";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  getAllRoutePoint,
  getAllRoutePointByMenu,
} from "../../actions/RoutePointAction";
import CreateIcon from "@mui/icons-material/Create";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  addWayPoint,
  deleteWayPoint,
  removeWayPoint,
  updateWayPoint,
} from "../../actions/RoutePointAction";
import DialogModel from "../Model/DialogModel";
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";
import { GOOGLE_API_KEY } from "../../utils/helper";
import keycloakService from "../../keycloakService";
import { ROLE } from "../../utils/helper";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  NativeSelect,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Menus from "../TableMenu/Menus";
import { FilterMenu } from "../../utils/enum";

const StyledDiv = styled("div")(({ theme }) => ({
  "& .table": {
    minWidth: 650,
  },
  "& .addIcon": {
    color: "#05234A",
    border: "solid 1px #05234A",
    padding: "2px",
    margin: "5px",
    borderRadius: "100%",
  },
  "& .clickedAddIcon": {
    color: "white",
    backgroundColor: "#05234A",
    padding: "2px",
    margin: "5px",
    borderRadius: "100%",
  },
  "& .addButton": {
    color: "white",
    backgroundColor: "#4caf50",
    padding: "2px",
    margin: "5px",
    borderRadius: "100%",
  },
  "& .addButtonDisable": {
    color: "white",
    backgroundColor: "gray",
    padding: "2px",
    margin: "5px",
    borderRadius: "100%",
  },
  "& .addButtonAdd": {
    color: "white",
    backgroundColor: "#4caf50",
    padding: "10px",
    margin: "10px",
    borderRadius: "100%",
    cursor: "pointer",
  },
  "& .selectedMenu": {
    backgroundColor: "#05234A",
    color: "white",
    "&:hover": {
      backgroundColor: "#05234A",
    },
  },
}));

const dropDownLimit = 8;

function AddNewRoutePoint() {
  const [location, setLocation] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [routeList, setRouteList] = useState([]);
  const [begin, setBegin] = useState(0);
  const [end, setEnd] = useState(0);
  const [sliceList, setSliceList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState("all");
  const [newArrayList, setNewArrayList] = useState(0);
  const [open, setOpen] = useState(false);
  const [wayPoint, setWayPoint] = useState(null);
  const inputRef = useRef();
  const hasSuperAdmin = keycloakService.hasRole([ROLE.SuperAdmin]);
  const [showEdit, setShowEdit] = useState(false);
  const [needEdit, setNeedEdit] = useState("");
  const [newEditValues, setNewEditValues] = useState({
    id: "",
    status: "",
    available: "",
  });
  const [lineProgress, setLineProgress] = useState(false);

  const reFetchingRoutePoint = async () => {
    setLineProgress(true);
    const routePointList = getAllRoutePointByMenu(
      FilterMenu[selectedMenu],
      (res) => {
        setRouteList(res);
        setLineProgress(false);
      }
    );
    await routePointList();
  };

  useEffect(() => {
    setLineProgress(true);
    const fetchingFunction = async () => {
      // const routePointList = getAllRoutePoint((res) => {
      const routePointList = getAllRoutePointByMenu(
        FilterMenu[selectedMenu],
        (res) => {
          setRouteList(res);
          setLineProgress(false);
        }
      );
      await routePointList();
    };
    fetchingFunction();
  }, [selectedMenu]);

  useEffect(() => {
    const statusMap = {
      all: null,
      published: "PUBLISHED",
      pen_publish: "PENDING_PUBLISH",
      pen_delete: "PENDING_DELETION",
      delete: "DELETED",
    };

    let filteredList = routeList;
    if (statusMap[selectedMenu]) {
      filteredList = routeList.filter(
        (item) => item.wayPointStatus === statusMap[selectedMenu]
      );
    }

    const totalCount = filteredList.length;
    setNewArrayList(totalCount);

    if (begin === 0 && end === 0) {
      const itemsPerPage = Math.min(dropDownLimit, totalCount);
      setEnd(itemsPerPage);
      setSliceList(filteredList.slice(0, itemsPerPage));
    } else {
      setSliceList(filteredList.slice(begin, end));
    }
  }, [routeList, begin, end, selectedMenu]);

  useEffect(() => {
    setBegin(0);
    setEnd(0);
  }, [selectedMenu]);

  const handlePlaceChange = () => {
    const places = inputRef.current.getPlaces();
    if (places && places.length > 0) {
      setLocation(places[0]);
    }
  };

  const addingWayPoint = async () => {
    const wayPoint = {
      wayPoint: {
        placeId: location.place_id,
        address: location.formatted_address,
        location: {
          latLng: {
            latitude: location.geometry.location.lat(),
            longitude: location.geometry.location.lng(),
          },
          heading: 0,
        },
        displayName: {
          text: location.vicinity,
          languageCode: "en",
        },
      },
    };
    setLineProgress(true);
    const wayPointPost = addWayPoint(wayPoint, reFetchingRoutePoint);
    await wayPointPost();

    if (hasSuperAdmin) {
      setSelectedMenu("published");
    } else {
      setSelectedMenu("pen_publish");
    }
  };

  const handleBack = () => {
    if (begin === 0) return;
    const newBegin = Math.max(0, begin - dropDownLimit);
    setBegin(newBegin);
    setEnd(Math.min(newBegin + dropDownLimit, routeList.length));
    //
  };

  const handleForward = () => {
    if (end >= newArrayList) return;
    const newBegin = begin + dropDownLimit;
    const newEnd = Math.min(newBegin + dropDownLimit, routeList.length);
    setBegin(newBegin);
    setEnd(newEnd);
  };

  const correctColorForStatus = (status) => {
    switch (status) {
      case "PUBLISHED":
        return "#35AA2B";
      case "DELETED":
        return "#EC6767";
      case "PENDING_PUBLISH":
        return "black";
      default:
        return "orange";
    }
  };

  const correctColorForAvailability = (availability) => {
    switch (availability) {
      case "TODO":
        return "primary";
      case "IN_COMPLETE":
      case "COMPLETED":
        return "secondary";
      case "COMPLETE":
      case "COMPLETED":
        return "success";
      default:
        return "default";
    }
  };

  const handleState = (status) => {
    setSelectedMenu(status);
    setBegin(0);
    setEnd(0);
  };

  const handleDelete = async (id) => {
    if (!id) return;

    setLineProgress(true);
    if (hasSuperAdmin) {
      const deleted = deleteWayPoint(id, reFetchingRoutePoint);
      await deleted();
      setSelectedMenu("delete");
    } else {
      const remove = removeWayPoint(id, reFetchingRoutePoint);
      await remove();
      setSelectedMenu("pen_delete");
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const handleOpenDeleteDialog = (row) => {
    setWayPoint(row);
    setOpen(true);
  };

  const handleEdit = (edit) => {
    setNewEditValues({
      id: edit.id,
      status: edit.wayPointStatus,
      available: edit.routePointAvailability,
    });
    setShowEdit(true);
    setNeedEdit(edit.id);
  };

  const handleCloseEdit = () => {
    setShowEdit(false);
    setNeedEdit("");
  };

  const handleUpdate = async () => {
    if (!newEditValues) return;

    const updatedWayPoint = {
      id: newEditValues.id,
      wayPointStatus: newEditValues.status,
      routePointAvailability: newEditValues.available,
    };

    setLineProgress(true);
    const update = updateWayPoint(updatedWayPoint, reFetchingRoutePoint);
    await update();

    switch (newEditValues.status) {
      case "PUBLISHED":
        setSelectedMenu("published");
        break;
      case "PENDING_PUBLISH":
        setSelectedMenu("pen_publish");
        break;
      case "DELETED":
        setSelectedMenu("delete");
        break;
      default:
        break;
    }

    setShowEdit(false);
    setNeedEdit("");
  };
  const handleValidation = () => {
    if (
      newEditValues.status === "PENDING_PUBLISH" &&
      newEditValues.available != "TODO"
    ) {
      return true;
    } else if (
      newEditValues.status === "PENDING_DELETED" &&
      (newEditValues.available != "TODO" ||
        newEditValues.available != "COMPLETED")
    ) {
      return true;
    } else if (
      newEditValues.status === "DELETED" &&
      newEditValues.available === "ASSIGNED"
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <StyledDiv>
      <Card style={{ border: "#083979 1px solid", borderRadius: "15px" }}>
        <CardContent>
          <Grid
            container
            spacing={1}
            style={{ justifyContent: "space-between" }}
          >
            <Menus selectedMenu={selectedMenu} handleState={handleState} />
            <Grid item style={{ display: "flex" }}>
              <Grid
                item
                style={{
                  display: showSearch ? "block" : "none",
                  marginRight: "10px",
                }}
              >
                <LoadScript
                  googleMapsApiKey={GOOGLE_API_KEY}
                  libraries={["places"]}
                  style={{ margin: "10px", padding: "10px", width: "100%" }}
                >
                  <StandaloneSearchBox
                    onLoad={(ref) => (inputRef.current = ref)}
                    onPlacesChanged={handlePlaceChange}
                  >
                    <input
                      type="text"
                      placeholder="Search Way Points"
                      style={{
                        margin: "10px",
                        padding: "10px",
                        borderRadius: "10px",
                        width: "150%",
                      }}
                    />
                  </StandaloneSearchBox>
                </LoadScript>
              </Grid>
              <Grid
                style={{
                  marginLeft: "110px",
                  marginTop: "5px",
                  display: "flex",
                }}
              >
                <Grid
                  item
                  style={{
                    display: location ? "block" : "none",
                    marginTop: "10px",
                  }}
                  onClick={addingWayPoint}
                >
                  <label className="addButtonAdd">Add</label>
                </Grid>
                <Grid item>
                  <AddIcon
                    fontSize="large"
                    style={{
                      display: location ? "none" : "block",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowSearch(!showSearch)}
                    className={showSearch ? "clickedAddIcon" : "addIcon"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <TableContainer component={Paper}>
          <Table className="table" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Route Point ID</TableCell>
                <TableCell>Publish Status</TableCell>
                <TableCell>RoutePoint Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lineProgress && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              )}
              {sliceList.length > 0 &&
                sliceList.map((row) =>
                  showEdit && needEdit === row.id ? (
                    <TableRow key={row.id}>
                      <TableCell>{row.wayPoint.address}</TableCell>
                      <TableCell>
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl>
                            <InputLabel
                              variant="standard"
                              htmlFor="uncontrolled-native"
                            >
                              Way Point Status
                            </InputLabel>
                            <NativeSelect
                              defaultValue={newEditValues.status}
                              inputProps={{
                                name: "status",
                                id: "uncontrolled-native",
                              }}
                              onChange={(e) =>
                                setNewEditValues((prevValue) => ({
                                  ...prevValue,
                                  status: e.target.value,
                                }))
                              }
                            >
                              <option value="PENDING_PUBLISH">
                                PENDING PUBLISH
                              </option>
                              <option value="PUBLISHED">PUBLISHED</option>
                              <option value="DELETED">DELETED</option>
                            </NativeSelect>
                          </FormControl>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl>
                            <InputLabel
                              variant="standard"
                              htmlFor="uncontrolled-native-availability"
                            >
                              Availability
                            </InputLabel>
                            <NativeSelect
                              defaultValue={newEditValues.available}
                              inputProps={{
                                name: "availability",
                                id: "uncontrolled-native-availability",
                              }}
                              onChange={(e) =>
                                setNewEditValues((prevValue) => ({
                                  ...prevValue,
                                  available: e.target.value,
                                }))
                              }
                            >
                              <option value="TODO">TODO</option>
                              <option value="COMPLETED">COMPLETED</option>
                              <option value="ASSIGNED">ASSIGNED</option>
                            </NativeSelect>
                          </FormControl>
                        </Box>
                        {/* )} */}
                      </TableCell>
                      <TableCell>
                        <Button
                          style={{ color: "#E1BE43", borderRadius: "100%" }}
                          onClick={handleUpdate}
                          disabled={handleValidation()}
                        >
                          <DoneIcon
                            fontSize="large"
                            className={
                              handleValidation()
                                ? "addButtonDisable"
                                : "addButton"
                            }
                          />
                        </Button>
                        <Button
                          style={{ color: "#E1BE43", borderRadius: "100%" }}
                          onClick={handleCloseEdit}
                        >
                          <CancelIcon fontSize="large" />
                        </Button>
                        <Button
                          style={{ color: "#EC6767", borderRadius: "100%" }}
                          onClick={() => handleOpenDeleteDialog(row)}
                        >
                          <DeleteOutlineIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableRow key={row.id}>
                      <TableCell>{row.wayPoint.address}</TableCell>
                      <TableCell
                        style={{
                          color: correctColorForStatus(row.wayPointStatus),
                        }}
                      >
                        {row.wayPointStatus}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={row.routePointAvailability}
                          color={correctColorForAvailability(
                            row.routePointAvailability
                          )}
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        {hasSuperAdmin && (
                          <Button
                            style={{ color: "#E1BE43", borderRadius: "100%" }}
                            onClick={() => handleEdit(row)}
                          >
                            <CreateIcon />
                          </Button>
                        )}
                        <Button
                          style={{ color: "#EC6767", borderRadius: "100%" }}
                          onClick={() => handleOpenDeleteDialog(row)}
                        >
                          <DeleteOutlineIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          display="flex"
          justifyContent="center"
          mt={3}
          style={{ margin: "10px" }}
        >
          <Grid container justifyContent="center" alignItems="center">
            <Button
              disabled={begin === 0}
              style={{
                border: "1px solid #05234A",
                borderRadius: "10px",
                margin: "2px",
              }}
              onClick={handleBack}
            >
              <ArrowBackIosIcon />
            </Button>
            <Button
              disabled={end >= newArrayList}
              style={{
                border: "1px solid #05234A",
                borderRadius: "10px",
                margin: "2px",
              }}
              onClick={handleForward}
            >
              <ArrowForwardIosIcon />
            </Button>
          </Grid>
        </Box>
      </Card>
      <DialogModel
        wayPoint={wayPoint}
        open={open}
        handleClose={handleClose}
        handleAgree={() => wayPoint && handleDelete(wayPoint.id)}
      />
    </StyledDiv>
  );
}

export default AddNewRoutePoint;
